__webpack_require__.p = "https://js-static.iimjobs.com/production/19.2.3/_next/";